/**
 * @file Automatically generated by barrelsby.
 */

export * from './get-query-param';
